<template>
  <div class="table-container">
    <div v-if="pagination && pagination.maxPage >= pagination.page && pages.length" class="pagination">
      <div class="icon-chevron left grey" :class="{ disabled: pagination.page === 0 }" @click="() => setPage(pagination.page - 1)"></div>

      <div v-if="pagination.page > 3 && !disableDots()" class="number" @click="() => setPage(0)">1</div>
      <div v-if="pagination.page > 3 && !disableDots()" class="number">...</div>

      <div v-for="number in pages" :key="number" class="number" :class="{ current: pagination.page === number }" @click="() => setPage(number)">
        {{ number + 1 }}
      </div>

      <div v-if="pagination.page < pagination.maxPage - 4 && !disableDots()" class="number">...</div>
      <div v-if="pagination.page < pagination.maxPage - 4 && !disableDots()" class="number" @click="() => setPage(pagination.maxPage - 1)">
        {{ pagination.maxPage }}
      </div>

      <div class="icon-chevron right grey" :class="{ disabled: pagination.page === pagination.maxPage - 1 }" @click="() => setPage(pagination.page + 1)"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pagination: {
      type: Object,
      required: true,
    },

    setPage: {
      type: Function,
      required: true,
    },

    disableDots: {
      type: Function,
      required: true,
    },

    tableValues: {
      type: Array,
      required: true,
    },

    pages: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      headers: [this.$t('creationDate'), ''],
    };
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
* {
  user-select: none;
}

.table-container {
  margin: 24px 0;

  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;

    .icon-chevron,
    .number {
      cursor: pointer;
      width: 22px;
      height: 22px;
      margin: 0 10px;

      &:hover {
        color: colors.$lightblue-color;
        font-weight: 500;
      }

      &.disabled {
        cursor: not-allowed;
        color: rgba(colors.$lightgrey-color, 0.5) !important;

        &:after {
          border-color: rgba(colors.$lightgrey-color, 0.5) !important;
        }
      }
    }

    .number {
      color: colors.$grey-color;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      &.current {
        color: colors.$lightblue-color;
        font-weight: 500;
      }

      &:hover {
        transform: scale(1.1);
      }
    }
  }
}
</style>
